export default "__VITE_ASSET__CgBK8K$p__"